import React from "react";

import { Box } from "@mui/material";

// -------------------------------------------------------------------------------------
const YesOrNoCell = ({ value, ...rest }) => {
  return (
    <Box display={"inline-flex"} justifyContent={"center"} {...rest}>
      {(value + "")?.toLowerCase() === "true" ? "Да" : "Нет"}
    </Box>
  );
};

export default YesOrNoCell;
